module.exports = __webpack_public_path__ + "img/fz.08bc6d9f.png";